import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { ItemDetailSectionSkeleton } from '@/experiences/sales-portal/domain/items/components/item-detail-section-skeleton';
import { View } from 'react-native';

/**
 * General-tab loading state for the item detail panel body — a section skeleton
 * (title row + card with four label/value rows).
 */
export const ItemDetailGeneralLoadingSkeleton: React.FC = () => {
  const [styles] = useStyles();
  return (
    <View
      accessibilityLabel={i18n.t(
        'sales_portal.order_entry.item_detail.a11y.loading',
      )}
      accessibilityRole="progressbar"
      style={styles.skeletonContainer}
    >
      <ItemDetailSectionSkeleton />
    </View>
  );
};

const useStyles = createStyles(() => ({
  skeletonContainer: {
    flexDirection: 'column',
  },
}));
